import { render, staticRenderFns } from "./UpcomingTasks.vue?vue&type=template&id=389d2f8b&"
import script from "./UpcomingTasks.vue?vue&type=script&lang=ts&"
export * from "./UpcomingTasks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports